import React, { useState, useEffect } from 'react';
import { Instagram, Phone } from 'lucide-react';
import { clinicInfo } from '../mockData';
import { openWhatsApp } from '@/lib/whatsapp';

const iconCircleBase =
  'inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-deep text-white shadow-md ring-1 ring-white/25 transition hover:bg-brand-ink hover:shadow-brand-lg hover:ring-white/35 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 active:scale-[0.97]';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    openWhatsApp({
      section: 'header',
      message: 'Olá! Vim pelo site e quero agendar uma avaliação sem compromisso.',
    });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-40 border-b transition-all duration-500 ${
        scrolled
          ? 'border-brand-ink/8 bg-white/90 py-2.5 shadow-sm backdrop-blur-xl'
          : 'border-transparent bg-brand-cream/85 py-3 backdrop-blur-md md:py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-center gap-3">
            <img
              src="/images/logo.jpeg"
              alt="Clínica Líder Odontologia"
              className="h-12 w-auto shrink-0 object-contain sm:h-14 md:h-16"
            />
            <div className="hidden min-w-0 sm:block">
              <p className="truncate font-display text-lg font-semibold leading-tight text-brand-ink">
                Ortodontia Líder
              </p>
              <div className="mt-0.5 flex items-center gap-1.5">
                <span className="text-[11px] tracking-wide text-brand-gold">★★★★★</span>
                <span className="text-xs font-medium text-brand-muted">{clinicInfo.rating}</span>
              </div>
            </div>
          </div>

          <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
            {[
              ['sobre', 'Sobre'],
              ['tratamentos', 'Tratamentos'],
              ['localizacao', 'Localização'],
              ['contato', 'Contato'],
            ].map(([id, label]) => (
              <button
                key={id}
                type="button"
                onClick={() => scrollToSection(id)}
                className="rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-brand-muted transition hover:bg-brand-ink/5 hover:text-brand-deep"
              >
                {label}
              </button>
            ))}
          </nav>

          <div className="flex shrink-0 items-center gap-2 sm:gap-2.5">
            <a
              href="https://www.instagram.com/ortodontialider"
              target="_blank"
              rel="noopener noreferrer"
              className={iconCircleBase}
              aria-label="Instagram da Ortodontia Líder"
            >
              <Instagram className="h-5 w-5" strokeWidth={1.85} />
            </a>
            <button
              type="button"
              onClick={handleWhatsAppClick}
              className={iconCircleBase}
              aria-label="Agendar pelo WhatsApp"
            >
              <Phone className="h-5 w-5" strokeWidth={1.85} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
